import React from 'react';

import { Text } from '@betterment/samba-react';

import { BannerWrapper } from './BannerWrapper';

export const Spouse401kBanner: React.FC = () => {
  return (
    <BannerWrapper>
      <Text as="p">
        A plan conversion from a previous provider is pending for your client’s solo 401(k) accounts. The balances of
        these accounts will not reflect prior contributions until the conversion is finalized by the plan owner.
      </Text>
    </BannerWrapper>
  );
};
